import { Component, Inject, OnInit, ViewEncapsulation } from "@angular/core";
import { MatDialog, MAT_DIALOG_DATA } from "@angular/material/dialog";
import { ActivatedRoute } from "@angular/router";
import { TranslateService } from "@ngx-translate/core";
import { HelperService } from "app/helpers/helper.service";
import { PostService } from "app/helpers/post.service";
import { ConsByStateService } from "app/main/cons-by-state/cons-by-state.service";
import { environment } from "environments/environment";
import { UiService } from "../UiService";

@Component({
  selector: "app-movepanchayat",
  templateUrl: "./movePanchayat.component.html",
  styleUrls: ["./movePanchayat.component.scss"],
  encapsulation: ViewEncapsulation.None,
})
export class MovePanchayatComponent implements OnInit {
  // @ViewChild("title") title;
  header_title = "To Change Title";
  error_msg = "Please enter a valid name";
  placeholder = "Name";
  subTitle;
  selectedDropdown;
  selectedConstDropdown;
  enableButton = true;
  showError = false;
  unionList: any = "";
  constituencyList: any = "";
  dropdownData: any;
  parameters: any;
  union_type: any;
  Reqeust: any;
  panchayatId: any;
  searchTxt: any;

  constructor(
    private dialog: MatDialog,
    private translate: TranslateService,
    private postService: PostService,
    private uiService: UiService,
    private activatedRoute: ActivatedRoute,
    private helper: HelperService,
    private consByStateService: ConsByStateService,
    @Inject(MAT_DIALOG_DATA) public data: any
  ) { }

  ngOnInit(): void {
    this.consByStateService
      .fetchConstituencyList(this.data.parameters)
      .subscribe((val) => {
        this.constituencyList = val?.constituencies;
      });
    this.unionList = this.data.dataList;
    this.panchayatId = this.data.panchayat_id;
    this.union_type = this.data.union_type;
  }

  onClickCancel() {
    // this.data.onCancel();
  }

  onDropdownChange() { }

  onConstDropdownChange() {
    this.postService
      .get(
        environment.GET_UNIONLIST + "?&const_id=" + this.selectedConstDropdown
      )
      .subscribe((val) => {
        // this.data.onSuccess(val);
        this.unionList = val.data;
        this.dropdownData = this.unionList.filter((elm) => {
          return elm.union_type == 86;
        });
      });
  }
  onClickSubmit() {
    //Checking for white spaces
    this.Reqeust = {
      panchayat_id: this.panchayatId,
      cons_circle_id: this.selectedDropdown,
    };
    this.uiService.showLoading();
    this.postService
      .post(environment.PANCHAYAT_MOVE, this.Reqeust)
      .subscribe((val) => {
        this.data.onSuccess(val);
        this.uiService.hideLoading();
      });
  }
}
